export default __webpack_public_path__ + "d6c77a7f1161b2e67015738de7350e1e.svg";